import { WAITLIST_URL, CTA_TEXT } from "@/lib/constants";
import { trackEvent } from "@/lib/analytics";

export const CTAButton = ({
  eventName = "cta_click",
  variant = "solid",
  size = "md",
  className = "",
  testId = "cta-waitlist-button",
}) => {
  const sizes = {
    sm: "px-5 py-2.5 text-[13px]",
    md: "px-7 py-3.5 text-sm",
    lg: "px-9 py-4.5 text-[15px]",
  };

  const variants = {
    solid:
      "bg-[#171717] text-[#F8F7F3] hover:bg-[#176B4D] active:scale-[0.98]",
    outline:
      "bg-transparent text-[#171717] border border-[#171717]/15 hover:border-[#171717]/40 hover:bg-[#171717]/[0.03] active:scale-[0.98]",
    light:
      "bg-[#F8F7F3] text-[#171717] hover:bg-[#B8D99A]/40 active:scale-[0.98]",
  };

  return (
    <a
      href={WAITLIST_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent(eventName)}
      data-testid={testId}
      aria-label={`${CTA_TEXT} — opens Quantify signup form in a new tab`}
      className={`inline-flex items-center justify-center gap-2 rounded-full font-medium tracking-wide whitespace-nowrap transition-[background-color,border-color,transform] duration-300 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#176B4D] focus-visible:ring-offset-2 focus-visible:ring-offset-[#F8F7F3] ${sizes[size]} ${variants[variant]} ${className}`}
    >
      {CTA_TEXT}
    </a>
  );
};
